"use client";
import { Id } from "@/convex/_generated/dataModel";
import mixpanel from "mixpanel-browser";

const initMixpanel = () => {
  mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN!, { autocapture: true, ignore_dnt: true });
};

const identify = async (userId: Id<"users">) => {
  await mixpanel.identify(userId.toString());

  let ip = "0";
  const ipResponse = await fetch("/api/ip");

  if (ipResponse.ok) {
    const ipData = (await ipResponse.json()) as { ip: string };
    ip = ipData.ip;
  }

  await mixpanel.people.set(userId.toString(), {
    ip,
  });
};

export { initMixpanel, identify };
